export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_30-db6fdf0885db126745ab244f41f9d2b5.jpg";